import { render, staticRenderFns } from "./InputDialog.vue?vue&type=template&id=4c488bb7&scoped=true&"
import script from "./InputDialog.vue?vue&type=script&lang=js&"
export * from "./InputDialog.vue?vue&type=script&lang=js&"
import style0 from "./InputDialog.vue?vue&type=style&index=0&id=4c488bb7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c488bb7",
  null
  
)

export default component.exports